import * as React from 'react';
import { Link } from 'react-router-dom';
import styled from '../../theme';

const Container = styled.div`
  position: fixed;
  top: 35px;
  right: 35px;
  border: 1px solid ${props => props.theme.color.body2};
  border-radius: 100%;
  width: 30px;
  height: 30px;
  transition: 0.2s ease color, 0.2s ease background-color;
  display: none;
  z-index: 1;

  @media (min-width: ${props => props.theme.mobileBreakpoint}px) {
    display: block;
  }

  &:hover {
    color: #fff;
    background-color: ${props => props.theme.color.body2};

    a {
      color: #fff;
    }
  }

  a {
    color: ${props => props.theme.color.body2};
    text-decoration: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
  }
`;

function GlobalAboutLink() {
  return (
    <Container>
      <Link to="/about">i</Link>
    </Container>
  );
}

export default GlobalAboutLink;



// WEBPACK FOOTER //
// ./src/scenes/Project/GlobalAboutLink.tsx